
define('css!ui/badge/css/badge',[],function(){});
